import React, { useMemo, useState } from 'react';
import { useErrorImport } from '@/store/ImportRequest/useErrorImport';
import { Input, Modal, Table } from 'antd';

interface ImportErrorModalProps {
    importId: number | null;
    open: boolean;
    onClose: () => void;
}

interface ImportErrorRow {
    id: number;
    productName: string;
    reason: string;
}

export const ErrorModal = ({
    open,
    onClose,
    importId,
}: ImportErrorModalProps) => {
    const { data, isLoading } = useErrorImport(importId);
    const [search, setSearch] = useState('');

    const importErrorsObject = data?.import_errors || {};

    const importErrorsArray: ImportErrorRow[] = Object.entries(
        importErrorsObject,
    ).map(([productName, reason], index) => ({
        id: index + 1,
        productName,
        reason: String(reason),
    }));

    const filteredData = useMemo(() => {
        return importErrorsArray.filter((item) =>
            item.productName.toLowerCase().includes(search.toLowerCase()),
        );
    }, [importErrorsArray, search]);

    return (
        <Modal
            title="Falhas na importação"
            open={open}
            onCancel={onClose}
            footer={null}
            width={800}
        >
            <Input
                placeholder="Buscar..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                style={{ marginBottom: 16 }}
                allowClear
            />
            <Table
                loading={isLoading}
                dataSource={filteredData}
                rowKey="id"
                pagination={{ pageSize: 5 }}
                scroll={{ x: 'max-content' }}
                columns={[
                    {
                        title: 'ID',
                        dataIndex: 'id',
                        width: 60,
                    },
                    {
                        title: 'Nome do produto',
                        dataIndex: 'productName',
                        width: 300,
                        ellipsis: true,
                    },
                    {
                        title: 'Motivo da falha',
                        dataIndex: 'reason',
                        width: 400,
                    },
                ]}
            />
        </Modal>
    );
};
